import axios from "axios";

class ApiBase
{
    async get(uri) {
        const apiBase = "https://www.nsru.ac.th/api/api/";
        const response = await axios.get(apiBase + uri)
        return response.data.data;
    }
}

export default ApiBase